import {useSelector} from 'react-redux';

import {useParams} from 'react-router-dom';

import {accountSelector} from 'features/accounts/selectors';

export const useAccount = () => {
    const {account} = useParams();

    const selected = useSelector((state) => accountSelector(state, account));

    return selected;
};
